<template>
    <div class="sticky top-0 z-10" data-test="select-search">
        <span class="absolute shrink-0 inset-y-0 left-0 flex items-center justify-center w-9 pointer-events-none" data-test="search-icon">
            <InterfaceSearch class="text-gray-400" :class="$ui.oldFontScale ? 'h-3.5 w-3.5' : 'h-3 w-3'" />
        </span>
        <input
            class="form-input pl-9 pr-3 w-full border-0 text-base | focus:ring-0"
            :class="{ 'sm:text-sm': !$ui.oldFontScale }"
            data-test="search-input"
            type="text"
            :value="value"
            ref="input"
            @input="$emit('input', $event.target.value)"
        >
    </div>
</template>

<script>
    import InterfaceSearch from '../../assets/svg/line/interface-search.svg';

    export default {
        components: {
            InterfaceSearch,
        },

        props: {
            value: {
                type: String,
                required: true,
            },
        },

        computed: {
            activeElement() {
                return document.activeElement;
            },
            inputElement() {
                return this.$refs.input;
            },
        },

        methods: {
            focus() {
                this.inputElement.focus();
            },
            isFocused() {
                return this.activeElement === this.inputElement;
            },
        },
    };
</script>
